import React from 'react';
import { useTranslation } from 'react-i18next';
import Widget from '../../models/Widget';
import { ReactComponent as WidgetsIcon } from '../../assets/icons-menu/widgets.svg';
import RenderUser from '../RenderUser';

interface WidgetItemProps {
    widget: Widget;
    openModal: (widget: Widget) => void;
    openDeleteModal: (widget: Widget) => void;
    visibleCheck?: boolean;
    isChecked?: boolean;
    onChecked?: (widget: Widget) => void;
};

const WidgetItem: React.FC<WidgetItemProps> = ({ widget, openModal, openDeleteModal, ...props }) => {

    const [t] = useTranslation();

    const isChecked = props.isChecked ?? false;
    const batchActive = props.visibleCheck ?? false;

    const typeLabel = t(`filter_button_${widget.mime_type}`);

    return (
        <div
            className="card mb-3"
            style={batchActive ? { cursor: 'pointer' } : undefined}
            onClick={batchActive ? () => props.onChecked?.(widget) : undefined}
        >
            <div className={`card-body screen-item${isChecked ? ' checked' : ''}`}>

                {/* Name + type badge */}
                <div className="screen-item__info">
                    <div className="screen-item__name">
                        <WidgetsIcon style={{ width: '16px', height: '16px', flexShrink: 0 }} />
                        <span className="ml-2">{ widget.name }</span>
                    </div>
                    <div className="screen-item__tags">
                        <span className="screen-item__status-badge screen-item__status-badge--configured">
                            { typeLabel }
                        </span>
                    </div>
                </div>

                {/* Actions */}
                <div className="screen-item__actions">
                    <RenderUser item={widget} />
                    <button
                        type="button"
                        style={{ background: 'none', border: 'none', padding: 0 }}
                        onClick={(e) => {
                            if (batchActive) { e.stopPropagation(); return; }
                            openModal(widget);
                        }}
                    >
                        <i className="iconsminds-pen screen-item__options pointer"></i>
                    </button>
                    <button
                        type="button"
                        style={{ background: 'none', border: 'none', padding: 0 }}
                        onClick={(e) => {
                            if (batchActive) { e.stopPropagation(); return; }
                            openDeleteModal(widget);
                        }}
                    >
                        <i className="iconsminds-close screen-item__options color-secondary-color pointer"></i>
                    </button>
                </div>

            </div>
        </div>
    );

};

export default React.memo(WidgetItem);
